import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';

import './cupons.css';
import QrScanner from '../../utils/QrScanner'; // Asegúrate de que la ruta sea correcta
import Socket from '../../utils/Socket.config';
import ErrorAlert from '../Alerts/ErrorAlert';
import { buildCloudinaryImageUrl } from '../../utils/CloudinaryImageUrl';

export const ModalCupon = ({ showModalCupon, setShowModalCupon, selectedCupon, token }) => {
  const navigate = useNavigate();
  const { business_code, branchoffice_code, machine_code_table } = useParams();
  const [showScanner, setShowScanner] = useState(false);
  const [qrData, setQrData] = useState('');
  const [showModalScanner, setShowModalScanner] = useState(false);

  let logo = localStorage.getItem('logo');

  const handleScan = (data) => {
    setQrData(data);
    setShowScanner(false);

  let jsonData = JSON.parse(data);

    if (jsonData.business) {
      sendCodeCupon(jsonData)
    }
  };


    const sendCodeCupon = (data) => {


     
  
        // Connection with the sockets server
        const socket = Socket({ "business_code": data.business, "branchoffice_code": data.branchoffice, "machine_code": data.machine });
        // we upate the data when the server send the signal of a new order 


        socket.emit('cuponInserted', {
            cuponCode: selectedCupon.code_prefix,
            token:data.token,
            validCode: data.session,
            machine_code:data.machine,
            business_code:data.business,
            branchoffice_code:data.branchoffice,
        });

        // Escuchar la validación del cupón
        socket.on('cuponValidated', (response) => {
            


            if (response.success) {
                // Mostrar cupón válido
               
                ErrorAlert("Cupon validado", response.message, "success");
            } else {
                
                // Mostrar error
                ErrorAlert("Cupón inválido", response.message, "error");
            }


        });

        return () => {
            socket.disconnect();
        }
    }


  return (<>
    <Modal
      show={showModalCupon}
      onHide={() => setShowModalCupon(false)}
      fullscreen
      centered
      contentClassName="modal-cupon-outer"
    >
      <Modal.Body className="modal-cupon-body">
        <div className="modal-cupon-container">
          {/* Imagen del producto */}
          <div className="modal-cupon-product">
            <img
              src={buildCloudinaryImageUrl({ url: selectedCupon.img != null ? selectedCupon.img : logo, width: 800, quality: "auto", type: "image" }) || undefined}
              alt="Producto"
              className="modal-cupon-img"
            />
            <div>
              <h4 className="modal-cupon-title">{selectedCupon.name}</h4>
              <div className="modal-cupon-discount">
                {selectedCupon.discount_type === "FIXED"
                  ? <>Aplica: ${selectedCupon.discount_value}</>
                  : selectedCupon.discount_type === "PERCENTAGE"
                    ? <>Descuento: {selectedCupon.discount_value}%</>
                    : null}
              </div>
              <div className="modal-cupon-description">{selectedCupon.decription}</div>
            </div>
          </div>
          {/* Código de cupón */}
          <div className="modal-cupon-code-section">
            <div className="modal-cupon-code">
              {selectedCupon.code_prefix}
            </div>
            <div className="modal-cupon-instructions">
              Ingresa numero de sesion del kiosko o caja
            </div>
          </div>




          {/* Botón */}
          <div className="modal-cupon-btn-section">
            <button
              className="modal-cupon-btn m-1"
              onClick={() => setShowModalCupon(false)}
            >
              Aplicar cupon aqui
            </button>

            <button
              className="modal-cupon-btn m-1"
              onClick={() => setShowModalScanner(true)}
            >
              Aplicar cupon en caja o kiosko
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>



    <Modal
      show={showModalScanner}
      onHide={() => setShowModalScanner(false)}
      fullscreen
      centered

    >
      <Modal.Body >


        <div className="modal-cupon-product">
          <img
            src={buildCloudinaryImageUrl({ url: selectedCupon.img != null ? selectedCupon.img : logo, width: 800, quality: "auto", type: "image" }) || undefined}
            alt="Producto"
            className="modal-cupon-img"
          />
          <div>
            <h4 className="modal-cupon-title">Escane el qr</h4>
            <div className="modal-cupon-description">Antes de escanear verifica que la maquina esta lista</div>
          </div>
        </div>

        <div className='m-3'>
          <QrScanner
          size={500}
            onScan={handleScan}
            onClose={() => setShowScanner(false)}
          /></div>

        {/* Código de cupón */}
        {qrData ? <>
          <div className="modal-cupon-code-section">
            <div className="modal-cupon-code">
              {qrData}
            </div>
          </div></> : <></>}




        {/* Botón */}
        <div className="modal-cupon-btn-section">
          <button
            className="modal-cupon-btn m-1"
            onClick={() => setShowModalScanner(false)}
          >
            Cancelar
          </button>


        </div>

      </Modal.Body>
    </Modal>


  </>)
}